import throttle from 'lodash/throttle';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import {connect} from 'react-redux';
import EventSchema from 'event/EventSchema';
import SpotList from './SpotList';
import SingleTermSearchControls from '../controls/SingleTermSearchControls';
import SpotListDestinationInfo from 'destination/SpotListDestinationInfo';

export const SpotListContainerMobile = ({
    spots,
    isEvent,
    hasEvent,
    event,
    destination,
    city,
    showListLoader,
    showLoadingComplete,
    loadNextPage,
    isEventListEnabled,
    isMapShowing,
    onToggleEventList,
    onListScroll,
    isMonthly,
    showDestinationInfo,
}) => {
    const {timezone} = city;
    const classes = classNames('SpotListContainer', 'scrolling');
    let startsISO;
    let endsISO;
    let startsInTimezone;
    let endsInTimezone;

    if (hasEvent) {
        startsInTimezone = moment.tz(event.starts, timezone);
        endsInTimezone = moment.tz(event.ends, timezone);
        startsISO = startsInTimezone.toISOString();
        endsISO = endsInTimezone.toISOString();
    }

    return (
        <div
            className={classes}
            itemScope={isEvent ? true : null}
            itemType={isEvent ? 'http://schema.org/Event' : null}
            onScroll={onListScroll ? throttle(onListScroll, 500) : null}
        >
            {hasEvent && (
                <EventSchema
                    url={event.search_url}
                    metaName={event.title}
                    metaDescription={event.meta_description}
                    starts={startsISO}
                    ends={endsISO}
                    destination={destination}
                    city={city}
                />
            )}
            <SingleTermSearchControls
                isMapShowing={isMapShowing}
                showDestinationInfoModal={!showDestinationInfo}
            />
            <SpotList
                spots={spots}
                showLoadMore={showDestinationInfo}
                showListLoader={showListLoader}
                showLoadingComplete={showLoadingComplete}
                isEventListEnabled={isEventListEnabled}
                onToggleEventList={onToggleEventList}
                loadNextPage={loadNextPage}
                onScroll={onListScroll}
            />
            {showDestinationInfo && (
                <SpotListDestinationInfo
                    city={city}
                    destination={destination}
                    isMonthly={isMonthly}
                    event={event}
                />
            )}
        </div>
    );
};

SpotListContainerMobile.propTypes = {
    spots: PropTypes.arrayOf(PropTypes.object).isRequired,
    isEvent: PropTypes.bool.isRequired,
    hasEvent: PropTypes.bool,
    isMonthly: PropTypes.bool.isRequired,
    event: PropTypes.object,
    destination: PropTypes.shape(DESTINATION_DATA).isRequired,
    city: PropTypes.object,
    showListLoader: PropTypes.bool,
    showLoadingComplete: PropTypes.bool,
    showDestinationInfo: PropTypes.bool,
    isEventListEnabled: PropTypes.bool,
    isMapShowing: PropTypes.bool,
    loadNextPage: PropTypes.func,
    onToggleEventList: PropTypes.func,
    onListScroll: PropTypes.func,
};

const mapStateToProps = state => {
    const {
        search: {
            data: {searchType},
        },
        city: {data: city},
        destination: {data: destination},
        event: {data: event},
        searchRequest: {monthly},
    } = state;
    const isEvent = searchType === 'event';

    return {
        searchType,
        isEvent,
        city,
        event,
        destination,
        hasEvent: isEvent && !isEmpty(event),
        isMonthly: monthly,
    };
};

export default connect(mapStateToProps)(SpotListContainerMobile);
